export const cardBody = {
    width: "200px",
    height: "200px",
    border: "1px solid black",
    cursor: "pointer",
    zIndex: "0",
    position: "relative"
};

export const imageBody = {
    width: "200px",
    height: "225px",
    border: "1px solid black",
    zIndex: "0",
    position: "relative"
};

export const videoBody = {
    width: "200px",
    height: "225px",
    border: "1px solid black",
    zIndex: "0",
    position: "relative"
};

export const cardTopBackground = {
    // border: "1px solid black",
    width: "175px",
    height: "25px"
};

export const cardMainBackground = {
    // border: "1px solid black",
    width: "200px",
    height: "175px"
};

export const imageCardTopHidden = {
    height: "50px",
    visibility: "hidden"
};

export const imageCardTopShow = {
    height: "50px",
    visibility: "visible",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
};

export const cardPicture = {
    height: "130px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

export const cardPicture_firstSection = {
    width: "25px"
};

export const cardPicture_middleSection = {
    width: "150px",
    textAlign: "center"
};

export const cardPicture_lastSection = {
    width: "25px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    height: "100px"
};

export const cardText = {
    height: "45px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    //border: "solid 1px black",
    textOverflow: "ellipsis"
    // overflow: "hidden"
};

export const albumImage = {
    width: "130px",
    height: "100px",
    cursor: "pointer"
};
